define.alias("shared/components/shared/button/media-uploader", "calendar/components/shared/button/media-uploader");